"use client";

import React from "react";
import Footer from "@/components/common/footer";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";
// import UpdatedHeader from "@/components/common/UpdatedHeader";

const SiteMap = () => {
  return (
    <main className="flex flex-col items-center justify-between bg-white min-h-screen">
      <div className="bg-[#191919] w-full blue_shadow">
        <GlobalHeaderNew />
      </div>
      <div className="mx-auto w-full">
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0">
          <div className="mx-auto lg:p-0 min-h-screen ">
            <div className="term-sec relative lg:top-[70px] md:top-[-10px] z-20 lg:text-left md:text-left mb-[100px]">
              <h1 className="text-[2rem] text-[#212529] font-medium text-center">
                Miles Education Sitemap
              </h1>
              <p className="text-[1rem] text-[#212529] font-medium text-center">
                Webpage Navigation
              </p>
              <ul className="list-group pt-[10px] text-[16px] mt-[30px] lg:px-0 px-[15px]">
                <li className="list-group-item border-x-[1px] border-t-[1px] border-[#dee2e6] py-[8px] px-[18px]">
                  <FontAwesomeIcon
                    className="text-[16px] text-[#0043b8] pr-[5px] pt-[5px] font-bold"
                    icon={faCaretRight}
                  />
                  <a
                    className="text-[#5b6efd]"
                    href="/accounting"
                    rel="noopener noreferrer"
                  >
                    Accounting
                  </a>
                  <ul className="list-group mt-[8px]">
                    <li className="list-group-item border-x-[1px] border-t-[1px] border-[#dee2e6] py-[8px] px-[18px] rounded-tl-[10px] rounded-tr-[10px]">
                      <FontAwesomeIcon
                        className="text-[16px] text-[#000] pr-[5px] pt-[5px] font-bold"
                        icon={faCaretRight}
                      />
                      <a
                        className="text-[#5b6efd]"
                        href="/us-jobs-for-accountants"
                        rel="noopener noreferrer"
                      >
                        Miles US Pathway
                      </a>
                    </li>
                    <li className="list-group-item border-x-[1px] border-t-[1px] border-[#dee2e6] py-[8px] px-[18px]">
                      <FontAwesomeIcon
                        className="text-[16px] text-[#000] pr-[5px] pt-[5px] font-bold"
                        icon={faCaretRight}
                      />
                      <a
                        className="text-[#5b6efd]"
                        href="/cpa"
                        rel="noopener noreferrer"
                      >
                        US CPA
                      </a>
                      {/* <ul className="list-group mt-[8px] mb-[8px] list-group-item">
                        <li className="list-group-item border-x-[1px] border-t-[1px] border-[#dee2e6] py-[8px] px-[18px] rounded-tl-[10px] rounded-tr-[10px]">
                          <FontAwesomeIcon
                            className="text-[16px] text-[#0043b8] pr-[5px] pt-[5px] font-bold"
                            icon={faCaretRight}
                          />
                          <a
                            className="text-[#5b6efd]"
                            href="/cpa/certified-public-accountant-overview"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            CPA Overview
                          </a>
                        </li>
                      </ul> */}
                    </li>
                    <li className="list-group-item border-x-[1px] border-t-[1px] border-[#dee2e6] py-[8px] px-[18px]">
                      <FontAwesomeIcon
                        className="text-[16px] text-[#000] pr-[5px] pt-[5px] font-bold"
                        icon={faCaretRight}
                      />
                      <a
                        className="text-[#5b6efd]"
                        href="/cma"
                        rel="noopener noreferrer"
                      >
                        US CMA
                      </a>
                      <ul className="list-group mt-[8px] mb-[8px] list-group-item">
                        <li className="list-group-item border-x-[1px] border-t-[1px] border-[#dee2e6] py-[8px] px-[18px] rounded-tl-[10px] rounded-tr-[10px]">
                          <FontAwesomeIcon
                            className="text-[16px] text-[#0043b8] pr-[5px] pt-[5px] font-bold"
                            icon={faCaretRight}
                          />
                          <a
                            className="text-[#5b6efd]"
                            href="/cma"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            CMA + Tax Overview
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className="list-group-item border-x-[1px] border-y-[1px] border-[#dee2e6] rounded-bl-[10px] rounded-br-[10px] py-[8px] px-[18px]">
                      <FontAwesomeIcon
                        className="text-[16px] text-[#000] pr-[5px] pt-[5px] font-bold"
                        icon={faCaretRight}
                      />
                      <a
                        className="text-[#5b6efd]"
                        href="/cpa/miles-cpa"
                        rel="noopener noreferrer"
                      >
                        Miles CPA Pathway
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="list-group-item border-x-[1px] border-t-[1px] border-[#dee2e6] rounded-tl-[10px] rounded-tr-[10px] py-[8px] px-[18px]">
                  <FontAwesomeIcon
                    className="text-[16px] text-[#000] pr-[5px] pt-[5px] font-bold"
                    icon={faCaretRight}
                  />
                  <a
                    className="text-[#5b6efd]"
                    href="/healthcare"
                    rel="noopener noreferrer"
                  >
                    Healthcare
                  </a>
                </li>
                <li className="list-group-item border-x-[1px] border-t-[1px] border-[#dee2e6] rounded-tl-[10px] rounded-tr-[10px] py-[8px] px-[18px]">
                  <FontAwesomeIcon
                    className="text-[16px] text-[#000] pr-[5px] pt-[5px] font-bold"
                    icon={faCaretRight}
                  />
                  <a
                    className="text-[#5b6efd]"
                    href="/business"
                    rel="noopener noreferrer"
                  >
                    Business
                  </a>
                </li>
                <li className="list-group-item border-x-[1px] border-t-[1px] border-[#dee2e6] rounded-tl-[10px] rounded-tr-[10px] py-[8px] px-[18px]">
                  <FontAwesomeIcon
                    className="text-[16px] text-[#000] pr-[5px] pt-[5px] font-bold"
                    icon={faCaretRight}
                  />
                  <a
                    href="/about-us"
                    className="text-[#5b6efd]"
                    rel="noopener noreferrer"
                  >
                    About
                  </a>
                </li>
                <li className="list-group-item border-x-[1px] border-y-[1px] border-[#dee2e6] rounded-bl-[10px] rounded-br-[10px] py-[8px] px-[18px]">
                  <FontAwesomeIcon
                    className="text-[16px] text-[#0043b8] pr-[5px] pt-[5px] font-bold"
                    icon={faCaretRight}
                  />
                  <a
                    className="text-[#5b6efd]"
                    href="/"
                    rel="noopener noreferrer"
                  >
                    More
                  </a>
                  <ul className="list-group mt-[8px] mb-[8px] list-group-item">
                    <li className="list-group-item border-x-[1px] border-t-[1px] border-[#dee2e6] py-[8px] px-[18px]">
                      <FontAwesomeIcon
                        className="text-[16px] text-[#0043b8] pr-[5px] pt-[5px] font-bold"
                        icon={faCaretRight}
                      />
                      <a
                        className="text-[#5b6efd]"
                        href="/cpa-cma-alumni"
                        rel="noopener noreferrer"
                      >
                        Alumni
                      </a>
                    </li>
                    <li className="list-group-item border-x-[1px] border-y-[1px] border-[#dee2e6] rounded-bl-[10px] rounded-br-[10px] py-[8px] px-[18px]">
                      <FontAwesomeIcon
                        className="text-[16px] text-[#0043b8] pr-[5px] pt-[5px] font-bold"
                        icon={faCaretRight}
                      />
                      <a
                        className="text-[#5b6efd]"
                        href="https://www.mileseducation.com/blog"
                        rel="noopener noreferrer"
                      >
                        Blog
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default SiteMap;
